import React from 'react'

const Statement = () => {
  return (
    <div className="topmost-statement">
      <h4>
        Statement of the Problem
      </h4>
      <p>
        A website is owned by Topmost to spearhead its new campaign into the into the online market but, since it was launched in late 2020, the platform has failed to deliver. With just a dozen orders made from the website.
        During the UX reserach the following problems were discovered from Topmost website:
      </p>

      <ul>
        <li>
          <h5>
            Very high bounce rate is noticed during the sites metrics check, lots of users leave the site almost immediatley after visiting.
            some of the interviewed users complained that the sites UI is not appealing.
          </h5>
          <p>some of the interviewed users complained that the sites UI is not appealing.</p>
        </li>
        <li>
          <h5>
            Abandonment rate at the Checkout stage is alarming.
          </h5>
          <p>It is with a rate of up to 95%</p>
        </li>
        <li>
          <h5>
            The platform is non-responsive. 
          </h5>
          <p>It is not ideal for mobiles and other small screens.</p>
        </li>
        <li>
          <h5>
            Poor arrangement & design of the website makes it ranks very low on search engines
          </h5>
          <p>Giving it an SEO problem i.e The site is not easily discovered by platforms like Google when trying to buy clothes online.</p>
        </li>
      </ul>
    </div>
  )
}

export default Statement